(function() {

    'use strict';

    angular.module('app').
    controller('CarriersZonesDetailController', CarriersZonesDetailController);

    CarriersZonesDetailController.$inject = ['$scope', 'Carrier', 'CarrierZonePostcodeFileDetailsTableService', 'CarriersZonesDetailTableService'];

    function CarriersZonesDetailController($scope, Carrier, CarrierZonePostcodeFileDetailsTableService, CarriersZonesDetailTableService) {

        var vm = this;

        vm.backToList = function() {
            history.back();
        };

        vm.searchTableData = CarriersZonesDetailTableService;

        init();

        function init() {
            vm.zonesPostcodes = CarrierZonePostcodeFileDetailsTableService;
        };
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersZonesDetailController.js